import { render, staticRenderFns } from "./customComponent.vue?vue&type=template&id=4dbb8cd1&"
import script from "./customComponent.vue?vue&type=script&lang=js&"
export * from "./customComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports